<template>
  <!--TODO: why NuxtLinkLocale is not working?-->
  <NuxtLink target="_blank" class="hotel-card" :to="getHotelPageAddr(hotel)" >
    <div class="hotel-card__label-container">
      <div class="hotel-card__label" style="display: none;">
        <div class="hotel-card__label-text">Label</div>
      </div>
    </div>
    <div class="hotel-card__content">
      <div class="hotel-card__image-container">
        <img
            v-if="!isNoPhoto"
            class="hotel-card__image"
            :alt="hotel.name"
            :src="hotelImageSrcset.src"
            :srcset="hotelImageSrcset.srcset"
            width="262" height="232"
            loading="lazy"
            @error="showPlaceholder"
        />
        <PhotoPlaceholder class="hotel-img-placeholder" v-show="isNoPhoto"/>
      </div>
      <div class="hotel-card__details">
        <div class="hotel-card__info">
          <div class="hotel-card__title-container">
            <h2 class="hotel-card__title">
              {{ hotel.name }}
            </h2>
            <span class="hotel-card__rating">
                <img class="hotel-card__star" v-for="i in hotel.rating" src="/images/hotel-card/rating-star.svg"  width="12" height="12"  alt="star">
              </span>
          </div>
          <div class="hotel-card__address" v-if="hotel.address">
            <div class="hotel-card__address-icon">
              <!--TODO: move svg to font -->
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9 16.4248L9.59737 17.0072C9.51898 17.0842 9.42582 17.1452 9.32324 17.1869C9.22065 17.2286 9.11066 17.25 8.99958 17.25C8.8885 17.25 8.77851 17.2286 8.67592 17.1869C8.57334 17.1452 8.48017 17.0842 8.40178 17.0072L8.39672 17.0014L8.38237 16.9874L8.33006 16.9354C8.03263 16.6359 7.74009 16.3317 7.45256 16.023C6.73065 15.2496 6.03939 14.4493 5.38031 13.6239C4.62769 12.6752 3.85819 11.6027 3.27347 10.5434C2.70141 9.50477 2.25 8.37949 2.25 7.3499C2.25 3.60528 5.28075 0.75 9 0.75C12.7192 0.75 15.75 3.60528 15.75 7.3499C15.75 8.37949 15.2986 9.50477 14.7265 10.5426C14.1418 11.6035 13.3732 12.6752 12.6197 13.6239C11.6978 14.7786 10.7131 15.884 9.66994 16.9354L9.61763 16.9874L9.60328 17.0014L9.59822 17.0064L9 16.4248ZM9 9.82487C9.67133 9.82487 10.3152 9.56411 10.7899 9.09997C11.2646 8.63582 11.5312 8.00631 11.5312 7.3499C11.5312 6.6935 11.2646 6.06399 10.7899 5.59984C10.3152 5.13569 9.67133 4.87494 9 4.87494C8.32867 4.87494 7.68484 5.13569 7.21014 5.59984C6.73543 6.06399 6.46875 6.6935 6.46875 7.3499C6.46875 8.00631 6.73543 8.63582 7.21014 9.09997C7.68484 9.56411 8.32867 9.82487 9 9.82487Z" fill="#292929"/>
              </svg>

            </div>
            <div class="hotel-card__address-text">
              {{ hotel.address }}
            </div>
          </div>
        </div>
        <div class="hotel-card__amenities" v-if="topHotelAmenities?.length">

          <div class="hotel-card__amenity" v-for="amenity in topHotelAmenities">
            <div class="hotel-card__amenity-icon">
              <span class="icon" :class="`icon ${amenity.icon}`"/>
            </div>
            <div class="hotel-card__amenity-text">{{amenity.name}}</div>
          </div>

        </div>
        <div class="hotel-card__description" v-if="false">
          {{shortDescription}}
        </div>
      </div>
    </div>
    <div class="hotel-card__price-container">
      <div class="hotel-card__price-indicator"></div>
      <div class="hotel-card__price-details">
        <div class="hotel-card__price-rating">
          <template v-if="hotel.avg_rating && hotel.avg_rating > 0">
            <div class="hotel-card__price-rating-text">
              <div class="hotel-card__price-rating-title">
                <span v-if="Number(hotel.avg_rating) >= 9">Excellent</span>
                <span v-else-if="Number(hotel.avg_rating) >= 7">Very Good</span>
                <span v-else-if="Number(hotel.avg_rating) >= 6">Good</span>
                <span v-else-if="Number(hotel.avg_rating) >= 4">Fair</span>
                <span v-else-if="Number(hotel.avg_rating) > 0">Poor</span>
                <span v-else>{{$t('No reviews')}}</span>
              </div>
              <div class="hotel-card__price-rating-reviews">{{ hotel.reviews_count }} {{$t('reviews')}}</div>
            </div>
            <div :class="['hotel-card__price-rating-score', ratingClass]">
              <div class="hotel-card__price-rating-score-text">{{ round(hotel.avg_rating) }}</div>
            </div>
          </template>

        </div>
        <div class="hotel-card__price-info" v-if="nightlyPriceDisplay || totalPriceDisplay">
          <div class="hotel-card__price">
            <div class="hotel-card__price-value">
              {{ nightlyPriceDisplay }}
            </div>
            <div class="hotel-card__price-total">
              <span>{{$t('Total')}}</span>
              <span>{{ totalPriceDisplay }}</span>
            </div>
            <div class="hotel-card__price-includes">{{$t("includes taxes & fees")}}</div>
          </div>
        </div>
      </div>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import {TOP_AMENITIES} from "~/utils/hotels";
import { useRouter, useRoute} from "vue-router";
import {imageUrlWithProxySrcset} from "~/utils/imageproxy";
import { formatPriceDisplay } from "~/utils/currency";

const localePath = useLocalePath()
const route = useRoute(),
    router = useRouter()

//props
const props = defineProps({
  hotel: {type: Object},
  route: {type: Object},
  cheapestRate: {type: Object},
  priceFrom: {type: Object}
})

const rrr = 9

// const rating = ref(parseFloat(props?.hotel?.rating))
const isNoPhoto = ref(props.hotel?.cover_image === null || props.hotel?.cover_image?.url.length === 0)
const hotelImageSrcset = computed(() => imageUrlWithProxySrcset(props.hotel?.cover_image?.url, 262, 232))
const shortDescription = cutDescription(props.hotel?.description)
const topHotelAmenities = (() => {
  const _hotelAmenities = props.hotel?.hotel_amenities ? props.hotel.hotel_amenities : []
  return TOP_AMENITIES.filter((amenity: any) => {
    return _hotelAmenities.find((hotelAmenity: any) => Number(hotelAmenity.ota_code) === amenity.code)
  }).slice(0,3)
})()

const ratingClass = computed(() => {
  const rating = round(props.hotel?.avg_rating)
  if (rating) {
    if ((rating as any) >= 9) {
      return 'excellent'
    } else if ((rating as any) >= 7) {
      return 'very-good'
    } else if ((rating as any) >=6) {
      return 'good'
    } else if ((rating as any) >= 4) {
      return 'fair'
    } else if ((rating as any) > 0) {
      return 'poor'
    }
  }
  return 'no-reviews'
})

const nightlyPriceDisplay = computed(() => formatPriceDisplay(props.cheapestRate?.night_rate))
const totalPriceDisplay = computed(() => formatPriceDisplay(props.priceFrom))

// JSON-LD structured data
const jsonLd = computed(() => ({
  "@context": "https://schema.org",
  "@type": "Hotel",
  "name": props.hotel?.name,
  "image": props.hotel?.cover_image?.url,
  "address": {
    "@type": "PostalAddress",
    "streetAddress": props.hotel?.address,
    "addressLocality": route.params.city,
  },
  ...(props.hotel?.avg_rating) && {
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": props.hotel?.avg_rating,
      "reviewCount": props.hotel?.reviews_count
    },
  },
  "priceRange": nightlyPriceDisplay.value
}))

useJsonld(() => (jsonLd.value));


//methods

function getHotelPageAddr(hotel: any): string {
  if (!hotel) return ''
  const queryFromObject = Object.keys(route.query)?.length ? `?${Object.keys(route.query).map(key => `${key}=${route.query[key]}`).join('&')}` : ''
  const _url = `/hotels/${route.params.city}/${hotel.id}-${hotel.slug}${queryFromObject}`

  return localePath(_url)
}

function showPlaceholder(event: any) {
  event.target.style.display = 'none'
  isNoPhoto.value = true
}

function cutDescription(value: any) {
  if (!value?.length) return ''

  const sentences = value.split('.')
  let paragraph = sentences[0]

  sentences.forEach( (sentence: any, index: any) => {
    if ((sentence.length + paragraph.length) < 130 && index > 0) {
      paragraph = [paragraph, sentence].join('.')
    }
  })

  return paragraph.length < 130 ? '1' + paragraph + '...' : '2' + paragraph.slice(0, 130) + '...'
}

//TODO: move to rating component
function round(rating: any) {
  return  ((rating ^ 0) === rating) ? (+rating).toFixed() : (+rating).toFixed(1)
}

</script>


<style scoped lang="scss">
$color-white: var(--white);
$color-light-gray: var(--grey-border);
$color-green: #44B50C;
$color-dark-green: var(--green);
$color-dark-gray: var(--black);
$color-mid-gray: var(--dark-grey);
$color-yellow: var(--yellow);
$color-blue: var(--blue);

$tablet-border: 1024px;
$mobile-border: 767px;

.hotel-card {
  width: 100%;
  height: 232px;
  background: var(--white);
  border-radius: 6px;
  box-shadow: 0 0 0 2px var(--grey-border); //instead of border
  justify-content: center;
  gap: 16px;
  display: inline-flex;
  position: relative;

  &.disabled-hotel {
    filter: grayscale(100%);
    opacity: 0.7;
  }

  //max-width: 834px;

  &:hover {
    box-shadow: 0 0 0 2px var(--light-grey-border);

    .hotel-card__price-value {
      color: var(--blue);
      font-size: 24px;
      transition: font-size 0.3s;
    }
  }

  @media screen and (max-width: $tablet-border) and (min-width: $mobile-border) {
    height: fit-content;
  }

  @media screen and (max-width: $mobile-border) {
    height: 100%;
    flex-direction: column;
    gap: 0;
  }

  &__label-container {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    display: inline-flex;
    position: absolute;
    left: 0;
    top: 16px;
    border-radius: 4px 4px 4px 0px;
    background: var(--Label-Green, #44B50C);
  }

  &__label {
    padding: 8px 12px;
    background: $color-green;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    display: flex;

    &-text {
      color: #fff;
      font-size: 14px;
      font-family: 'Albert Sans', sans-serif;
      font-weight: 600;
      line-height: 20px;
      word-wrap: break-word;
    }
  }

  &__content {
    flex: 1 1 0;
    align-self: stretch;
    justify-content: flex-start;
    align-items: flex-start;
    display: flex;
    margin: -2px 0 -2px -2px;

    @media screen and (max-width: $mobile-border) {
      height: 100%;
      border-bottom: 2px solid $color-light-gray;
    }
  }

  &__image-container {
    width: 262px;
    height: 100%;
    border-radius: 6px;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    display: flex;

    .hotel-img-placeholder {

      @media screen and (max-width: 768px) {
        height: 252px;
      }

      :deep(.icon) {
        font-size: 40px !important; //need to check size
      }
    }

    @media screen and (max-width: $tablet-border) and (min-width: $mobile-border) {
      width: 194px;
      height: 244px;
    }

    @media screen and (max-width: $mobile-border) {
      width: 100%;
      max-width: 131px;
      max-height: 262px;
      min-height: 252px;
      height: 100%;
      border-radius: 10px 0 0 0;
    }
  }

  &__image {
    object-fit: cover;
    width: 100%;
    height: 100%;

    @media screen and (max-width: 768px) {
      width: auto;
      height: 252px;
    }
  }

  &__details {
    flex: 1 1 0;
    padding: 20px 0 20px 24px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 12px;
    display: inline-flex;
    max-width: 384px;

    @media screen and (max-width: $tablet-border) and (min-width: $mobile-border) {
      gap: 10px;
    }

    @media screen and (max-width: $mobile-border) {
      padding: 14px 16px 16px 16px;
    }
  }

  &__info {
    align-self: stretch;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 8px;
    display: flex;
  }

  &__title-container {
    align-self: stretch;
    align-items: baseline;
    gap: 8px;
    display: flex;
    flex-wrap: wrap;

    @media screen and (max-width: $mobile-border) {
      display: inline-flex;
      flex-wrap: wrap;
    }
  }

  &__title {
    color: $color-dark-gray;
    max-width: 255px;
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    display: inline-flex;

    @media screen and (max-width: $tablet-border) and (min-width: $mobile-border) {
      max-width: 169px;
    }

    @media screen and (max-width: $mobile-border) {
      max-width: 100%;
      font-size: 16px;
    }
  }

  &__rating {
    justify-content: flex-start;
    align-items: center;
    gap: 2px;
    display: flex;

    @media screen and (max-width: $mobile-border) {
      display: inline-flex;
    }
  }

  &__star {
    color: $color-yellow;
  }

  &__address {
    align-self: stretch;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 8px;
    display: inline-flex;

    &-icon {

    }

    &-text {
      flex: 1 1 0;
      color: $color-mid-gray;
      font-size: 14px;
      font-family: 'Albert Sans', sans-serif;
      font-weight: 400;
      line-height: 20px;
      word-wrap: break-word;
    }
  }

  &__amenities {
    gap: 12px;
    display: flex;
    flex-wrap: wrap;

    @media screen and (max-width: $tablet-border) and (min-width: $mobile-border) {
      flex-direction: column;
      gap: 6px;
    }
  }

  &__amenity {
    align-items: center;
    gap: 6px;
    display: inline-flex;

    &-icon {
      justify-content: flex-start;
      align-items: center;
      gap: 8px;
      display: flex;
     font-size: 16px;
    }

    &-text {
      color: $color-mid-gray;
      font-size: 14px;
      font-family: 'Albert Sans', sans-serif;
      font-weight: 400;
      line-height: 20px;
      word-wrap: break-word;
    }
  }

  &__description {
    color: $color-mid-gray;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    word-wrap: break-word;

    @media screen and (max-width: $tablet-border) {
      display: none;
    }
  }

  &__price-container {
    margin: 20px 20px 20px 0;
    border-left: 1px solid var(--grey-border);
    gap: 12px;
    display: flex;
    flex: 1;
    max-width: 168px;
    justify-content: flex-end;

    @media screen and (max-width: $tablet-border) and (min-width: $mobile-border) {
      width: 100%;
      max-width: 189px;
      justify-content: flex-end;
      margin: 27px 17px 10px 0;
    }

    @media screen and (max-width: $mobile-border) {
      max-width: 100%;
      padding: 18px 16px;
      margin: 0;
      gap: 0;
    }

    &-indicator {
      width: 192px;
      align-self: stretch;
      transform: rotate(-90deg);
      transform-origin: 0 0;
      background: $color-light-gray;
    }


  }

  &__price {
    &-details {
      max-width: 155px;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-end;
      display: flex;

      @media screen and (max-width: $mobile-border) {
        max-width: 100%;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
      }
    }

    &-info {
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;
      gap: 12px;
      display: flex;
      text-align: right;
    }

    &-value {
      color: var(--black);
      text-align: right;
      font-size: 20px;
      font-weight: 600;
      line-height: 120%;
      margin-bottom: 3px;
    }

    &-includes {
      align-self: stretch;
      text-align: right;
      color: $color-mid-gray;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      word-wrap: break-word;
    }

    &-rating {
      justify-content: flex-end;
      align-items: center;
      gap: 8px;
      display: inline-flex;

      @media screen and (max-width: $mobile-border) {
        flex-direction: row-reverse;
      }

      &-text {
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        display: inline-flex;

        @media screen and (max-width: $mobile-border) {
          align-items: flex-start;
        }
      }

      &-title {
        color: $color-dark-gray;
        font-size: 14px;
        font-family: 'Albert Sans', sans-serif;
        font-weight: 500;
        line-height: 20px;
        word-wrap: break-word;
      }

      &-reviews {
        color: $color-mid-gray;
        font-size: 12px;
        font-family: 'Albert Sans', sans-serif;
        font-weight: 400;
        line-height: 16px;
        word-wrap: break-word;
      }

      &-score {
        height: 40px;
        width: 40px;
        padding: 8px 0;
        background: var(--black);
        border-radius: 4px;
        justify-content: center;
        align-items: center;
        gap: 4px;
        display: flex;

        &.excellent {
          background: var(--green);
        }

        &.very-good, &.good {
          background: var(--light-green);
        }

        &.poor, &.fair {
          background: var(--black);
        }

        &-text {
          flex: 1 1 0;
          text-align: center;
          color: #fff;
          font-size: 16px;
          font-family: 'Albert Sans', sans-serif;
          font-weight: 600;
          line-height: 24px;
          word-wrap: break-word;
        }
      }

    }

  }

  &__price-total {
    display: flex;
    justify-content: flex-end;
    gap: 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
  }
}

</style>
